/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgVolume2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M18.54 4.4a.75.75 0 011.062 0 10.75 10.75 0 010 15.2.75.75 0 01-1.061-1.06 9.25 9.25 0 000-13.08.75.75 0 010-1.06zm-7.214-.076a.75.75 0 01.425.676v14a.75.75 0 01-1.218.586L5.738 15.75H2.001a.75.75 0 01-.75-.75V9a.75.75 0 01.75-.75h3.737l4.795-3.836a.75.75 0 01.793-.09zm-1.075 2.237L6.47 9.586A.75.75 0 016 9.75h-3.25v4.5h3.25a.75.75 0 01.469.164l3.781 3.026V6.56zm4.76 1.369a.75.75 0 011.06 0 5.75 5.75 0 010 8.13.75.75 0 01-1.06-1.06 4.25 4.25 0 000-6.01.75.75 0 010-1.06z'
      />
    </svg>
  );
}

export default SvgVolume2;
